export default {"src":"/_next/static/media/icon-group-white.25eeb678.svg","height":17,"width":22};